/* @flow */

import React from "react";
import Wrapper from "components/Wrapper";
import cn from "classnames";
import { useTranslate } from "@awardit/react-use-translate";
import TryggEHandelIcon from "icons/trygg-e-handel.svg";
import Button from "components/Button";
import { Link } from "react-router-dom";

import styles from "./styles.scss";

type Props = {
  className: string,
  setToggleCookieDialogue: (value: boolean) => void,
};

const AppFooter = ({ className = "", setToggleCookieDialogue }: Props): React$Node => {
  const t = useTranslate();

  return (
    <Wrapper>
      <footer className={cn(styles.block, className)}>
        <nav aria-label={t("FOOTER.NAVIGATION")} className={styles.nav}>
          <p dangerouslySetInnerHTML={{ __html:
            t("FOOTER.COPYRIGHT", { year: new Date().getFullYear() }),
          }} />
          <div className={styles.termLinks}>
            <Button
              className={styles.link}
              onClick={() => setToggleCookieDialogue(true)}
            >
              {t("FOOTER.NEED_HELP.COOKIES")}
            </Button>
            &nbsp;|&nbsp;
            <Link className={styles.link} to="/accessibility">
              {t("FOOTER.ACCESSIBILITY")}
            </Link>
          </div>
          <TryggEHandelIcon aria-label={t("ICONS.ECOMMERCE")} />
        </nav>
      </footer>
    </Wrapper>
  );
};

export default AppFooter;
